import { Typography as MuiTypography } from "@mui/material";
import React from "react";
import useObservedExpression from "../../Hooks/useObservedExpression";
import useObservedText from "../../Hooks/useObservedText";
import { TypographyModel } from "../../Models/TypographyModel";
import formatValue from "../DataDisplay/formatValue";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

const TypographyComponent: React.FC<IComponentProps<TypographyModel>> = ({ component, context }) => {
  const componentLayoutSx = getComponentLayout(component);
  const text = useObservedText(component.Text, context, "TypographyComponent");
  const [value] = useObservedExpression(component.Value, context, "TypographyComponent");

  return (
    <MuiTypography variant={component.Variant ?? "body1"} color={component.Color} sx={{ ...componentLayoutSx, whiteSpace: "pre-wrap" }}>
      {text ?? formatValue(value, component.Format) ?? ""}
    </MuiTypography>
  );
};

export default TypographyComponent;
